import React from 'react';
import cx from 'classnames';
import SvgIcon from 'root/components/SvgIcon';
import t from 'common/i18n';
import SVG_ICONS from '~/assets/icons/icons';

export const Breadcrumb = (props) => {
  const pathArray = props.path.split('/');
  const breakpointIndex = 5;

  const onPathClick = (path) => {
    props.pathClickHandler(path);
  };

  const renderCrumbContent = (title, path, isLast) =>
    isLast ? (
      <span>{title}</span>
    ) : (
      <div className="pointer" onClick={() => onPathClick(path)}>
        {title}
      </div>
    );

  const renderMore = () => (
    <div key="more" className={cx('flex dn-ns items-center', 'f7 f5-ns', 'mr2')}>
      <SvgIcon size="sm" className="mr2" path={SVG_ICONS.ARROW_RIGHT} colorName="window-border" />
      ...
    </div>
  );

  const renderCrumb = (item, i) => {
    const path = pathArray.slice(0, i + 1).join('/');
    const title = item || t('dropbox.root_crumb');
    const isLast = i + 1 === pathArray.length;

    return (
      <div
        className={cx('items-center', 'f7 f5-ns', 'mr2', {
          b: isLast,
          'dn flex-ns': i >= breakpointIndex && !isLast,
          flex: i < breakpointIndex || isLast,
        })}
        data-test="crumb"
        key={path}
      >
        {i > 0 && <SvgIcon size="sm" className="mr2" path={SVG_ICONS.ARROW_RIGHT} colorName="window-border" />}
        {renderCrumbContent(title, path, isLast)}
      </div>
    );
  };

  const renderCrumbs = () => {
    const crumbs = pathArray.map(renderCrumb);
    if (crumbs.length > breakpointIndex) {
      crumbs.splice(breakpointIndex, 0, renderMore());
    }
    return crumbs;
  };

  return (
    <div data-test="breadcrumbs" className={`flex items-center pa6 ${props.className ? props.className : ''}`}>
      {renderCrumbs()}
    </div>
  );
};

export default Breadcrumb;
